import Vue from "vue";
import store from "@/store";
import { DateTime } from "luxon";

function padDate(value) {
  value = value.toString();
  if (value.length < 2) value = "0" + value;
  return value;
}

function parseDateTimeValue(value) {
  if (value === null || value === undefined || value === "") return null;

  if (DateTime.isDateTime(value)) {
    return value.isValid ? value : null;
  }

  if (value instanceof Date) {
    const dt = DateTime.fromJSDate(value);
    return dt.isValid ? dt : null;
  }

  const text = String(value).trim();
  if (!text) return null;

  let dt = DateTime.fromISO(text, { setZone: true });
  if (!dt.isValid) {
    dt = DateTime.fromSQL(text, { zone: "utc" });
  }
  if (!dt.isValid) {
    dt = DateTime.fromRFC2822(text);
  }
  if (!dt.isValid) {
    dt = DateTime.fromHTTP(text);
  }
  if (!dt.isValid) {
    const millis = Number(text);
    if (Number.isFinite(millis)) {
      dt = DateTime.fromMillis(millis);
    }
  }

  return dt.isValid ? dt : null;
}

Vue.filter("toCurrency", function (value) {
  let locale = "it-IT";
  if (store.state.user.id) locale = store.state.user.locale;

  if (typeof value !== "number") {
    return value;
  }

  var formatter = new Intl.NumberFormat(locale, {
    minimumFractionDigits: 2,
  });
  return formatter.format(value);
});

Vue.filter("toCurrencySymbol", function (value) {
  let locale = "it-IT";
  if (store.state.user.id) locale = store.state.user.locale;

  if (typeof value !== "number") {
    return value;
  }

  var formatter = new Intl.NumberFormat(locale, {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
  });
  return formatter.format(value);
});

Vue.filter("toDatePickerDate", function (value) {
  if (!value) return "";
  if (typeof value == "string") {
    try {
      const parsed = parseDateTimeValue(value);
      if (!parsed) return "";
      return (
        parsed.toFormat("yyyy") +
        "-" +
        padDate(parsed.toFormat("LL")) +
        "-" +
        padDate(parsed.toFormat("dd"))
      );
    } catch (err) {
      return "";
    }
  }
});

Vue.filter("toLocaleDate", function (value) {
  let locale = "it-IT";
  if (store.state.user.id) locale = store.state.user.locale;

  if (!value) return "";
  if (typeof value == "string") {
    try {
      const parsed = parseDateTimeValue(value);
      if (!parsed) return "";
      return parsed.setLocale(locale).toLocaleString({
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
      });
    } catch (err) {
      return "";
    }
  }
});

Vue.filter("unixToLocaleDateTime", function (value) {
  let locale = "it-IT";
  if (store.state.user.id) locale = store.state.user.locale;

  if (!value) return "";
  if (typeof value == "number") {
    try {
      const parsed = DateTime.fromSeconds(value);
      if (!parsed.isValid) return "";
      return parsed.setLocale(locale).toLocaleString({
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });
    } catch (err) {
      return "";
    }
  }
});

Vue.filter("unixToLocaleDateTimeNoSeconds", function (value) {
  let locale = "it-IT";
  if (store.state.user.id) locale = store.state.user.locale;
  if (!value) return "";
  if (typeof value == "number") {
    try {
      const parsed = DateTime.fromSeconds(value);
      if (!parsed.isValid) return "";
      return parsed.setLocale(locale).toLocaleString({
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    } catch (err) {
      return "";
    }
  }
});

Vue.filter("UTCToLocalDate", function (value) {
  try {
    const parsed = DateTime.fromSQL(String(value || ""), { zone: "utc" });
    if (!parsed.isValid) return null;
    return parsed.toLocal().toFormat("dd-MM-yyyy");
  } catch (err) {
    return null;
  }
});

Vue.filter("UTCToLocalTimeNoSec", function (value) {
  try {
    const parsed = DateTime.fromSQL(String(value || ""), { zone: "utc" });
    if (!parsed.isValid) return null;
    return parsed.toLocal().toFormat("dd-MM-yyyy HH:mm");
  } catch (err) {
    return null;
  }
});

Vue.filter("UTCToLocalTime", function (value) {
  try {
    const parsed = DateTime.fromSQL(String(value || ""), { zone: "utc" });
    if (!parsed.isValid) return null;
    return parsed.toLocal().toFormat("dd-MM-yyyy HH:mm:ss");
  } catch (err) {
    return null;
  }
});
